// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "HeaderNavItem-module--bx--text-truncate--end--Q41Pv";
export var bxTextTruncateFront = "HeaderNavItem-module--bx--text-truncate--front--GbHTx";
export var currentPage = "HeaderNavItem-module--currentPage--p9x4F";
export var currentPageAccordion = "HeaderNavItem-module--currentPageAccordion--L4HYH";
export var menuItem = "HeaderNavItem-module--menuItem--maYCW";
export var border = "HeaderNavItem-module--border--JW-bu";